// extracted by mini-css-extract-plugin
module.exports = {"dropdownWrapper":"currencySelector-module__dropdownWrapper___O4S+n"};